import { useDispatch, useSelector } from 'react-redux';

/**
 * Empty state when a parent has no active child (zero children or multi-child
 * before a selection). Keeps the session; does not send them to login.
 * Clicking a child sets selectedCustomerId (full switcher UI is PA-04).
 */
export default function NoChildSelected() {
	const dispatch = useDispatch();
	const children = useSelector((state) => state.auth.children) || [];
	const user = useSelector((state) => state.auth.user);

	const zero = children.length === 0;
	const title = zero ? 'No children linked' : 'Select a child';
	const body = zero
		? 'Your account has no linked students yet. Ask the school office to link a child, or sign out and try again later.'
		: 'Choose which child you want to order for.';

	const onSelect = (id) => {
		dispatch({ type: 'auth/setSelectedCustomerId', payload: id });
	};

	return (
		<section className='app-container'>
			<div className='inner-container flex flex-col gap-4 px-6 py-10'>
				<p className='text-sm text-bz-default/70'>
					Signed in as {user?.name || user?.email || 'parent'}
				</p>
				<h1 className='text-xl font-bold text-bz-default'>{title}</h1>
				<p className='text-base text-bz-default/80'>{body}</p>
				{children.length > 0 && (
					<ul className='mt-2 flex flex-col gap-2'>
						{children.map((child) => (
							<li key={child.id}>
								<button
									type='button'
									className='btn-actions w-full rounded-md px-4 py-3 text-left text-white'
									onClick={() => onSelect(child.id)}
								>
									<span className='block font-semibold'>
										{child.member?.name || `Child #${child.id}`}
									</span>
									<span className='block text-sm opacity-80'>
										{child.member?.on_list_attributes?.class || 'Class unknown'}
									</span>
								</button>
							</li>
						))}
					</ul>
				)}
			</div>
		</section>
	);
}
